import type { CommonDetail } from '@/types/domains/BusinessType';

export const HEADQUARTERS_NAME: string = 'オリエンタルバイオ株式会社' as const;
export const HEADQUARTERS_CEO_NAME: string = '渡邉　和晃' as const;
export const HEADQUARTERS_COO_NAME: string = '渡邉　和孝' as const;
export const HEADQUARTERS_PERSONAL_INFORMATION_INQUIRY_COUNTER: string =
  '個人情報相談窓口' as const;
export const HEADQUARTERS_POSTAL_CODE: string = '〒103-0023' as const;
// 支給デザインは半角（`design-src/20260810/tokutei.html:443`。全角は `faq.html` の1件のみ）。
// 2026-08-13 に「共有定数ごと支給に寄せる」判断を得たので半角にした。
// **波及先**（実測）: `/tokutei` 1箇所／`PRIVACY_POLICY`（個人情報の取扱い）3箇所 ＝
// `CommonsPrivacyPolicy` を出す画面／旧 `FaqConst` 3箇所（`/faq/basic` 2・`/faq/site-use` 1。
// PR #1284 で削除）。**`TERMS_OF_USE` は住所を参照していないので利用規約の本文は変わらない。**
export const HEADQUARTERS_ADDRESS: string =
  '東京都中央区日本橋本町1-5-4 住友不動産日本橋ビル1F' as const;
export const HEADQUARTERS_TELEPHONE_NUMBER: string = '03-6734-9222' as const;
export const HEADQUARTERS_FREEDIAL_TELEPHONE_NUMBER: string = '0120-079-996' as const;
/**
 * ゴールド・プラチナ会員専用の窓口（`/special-message`）。
 * **一般のフリーダイヤル（`HEADQUARTERS_FREEDIAL_TELEPHONE_NUMBER`）とは別の実在する番号**で、
 * 受付時間も違う（2026-08-13 レビューで確認。支給 `gp-member.html:36-46`）。
 */
export const GP_MEMBER_FREEDIAL_TELEPHONE_NUMBER: string = '0120-332-400' as const;
export const GP_MEMBER_RECEPTION_HOURS: string = '平日10:00-18:30' as const;
export const GP_MEMBER_RECEPTION_NOTE: string = '（土日祝休）' as const;

export const HEADQUARTERS_PERSONAL_INFORMATION_TELEPHONE_NUMBER: string = '03-6734-9236' as const;
export const HEADQUARTERS_FAX_NUMBER: string = '03-6734-9221' as const;
export const HEADQUARTERS_ONLINE_SHOP_MAIL_ADDRESS: string = 'shop@orientalbio.co.jp' as const;
export const HEADQUARTERS_PERSONAL_INFORMATION_EMAIL_ADDRESS: string =
  'spi@orientalbio.co.jp' as const;
export const HEADQUARTERS_OPENING_HOURS: string = '9:00～18:30' as const;
// 支給デザインの表記（`design-src/20260810/tokutei.html:457`。4件がこの形）。
// 2026-08-13 に「共有定数ごと支給に寄せる」判断を得た。
// **波及先**（実測）: `/tokutei` 1箇所／旧 `FaqConst` 3箇所（`/faq/basic` `/faq/site-use`）／
// 旧 `GuideConst` 1箇所（`/guide/return`）。**旧の4箇所は PR #1284 でファイルごと削除される**ので
// 統合後は `/tokutei` だけが参照する（新 `FaqGroupConst` / `ShoppingGuideConst` は支給の文言を直接持つ）。
// なお支給は `shopping-guide.html` と `gp-member.html` で `平日10:00-18:30`（半角）を使っており
// **支給の中で表記が揺れている**。それらのページは const を経由せず支給の文言をそのまま持つ。
export const HEADQUARTERS_RECEPTION_HOURS: string = '平日10：00〜18：30（土日祝を除く）' as const;
export const HEADQUARTERS_TELEPHONE_SERVICE_HOURS: string =
  '月～金（祝日、年末年始、その他当社の休業日を除く）の10:00～17:00' as const;
// 利用規約改定日
export const EFFECTIVE_DATE_IN_PRIVACY_POLICY_AND_TERMS_OF_USE: string = '2023年9月1日' as const;

export const FRONT_DOMAIN: string = 'https://www.orientalbio.co.jp' as const;
// 利用規約
export const TERMS_OF_USE: ReadonlyArray<CommonDetail> = [
  {
    type: 'text',
    content: 'オリエンタルバイオ公式オンラインショップ利用規約',
  },
  {
    type: 'text',
    content:
      'オリエンタルバイオ株式会社（以下「当社」といいます。）は、当社が運営するウェブサイト（以下「当社ウェブサイト」といいます。）において提供する、公式オンラインショップサービス（以下「本サービス」といいます。）に適用される利用規約（以下「本規約」といいます。）を下記に定めます。お客様には、本規約に従って本サービスをご利用いただきます。本規約にご同意いただけない場合は、本サービスのご利用をお控えください。',
  },
  {
    type: 'text',
    content: '第1条　適用範囲',
  },
  {
    type: 'orderedList',
    contents: [
      '本規約は当社公式オンラインショップを通じて、製品の購入その他サービスを利用する全てのお客様に適用されます。',
      '当社が当社ウェブサイト上に、本サービスに関する本規約に含まれる規定以外の追加の規定（以下「個別規定」といいます。）を掲載する場合、それらは本規約の一部を構成するものとし、本規約と個別規定の内容が相反し、又は矛盾する場合は、個別規定が優先されるものとします。',
    ],
  },
  {
    type: 'text',
    content: '第2条　本サービスの内容',
  },
  {
    type: 'orderedList',
    contents: [
      '本サービスは、お客様が当社ウェブサイトにおいて、会員登録を行い、当社に対して本サービスの提供のお申込みをいただき、当社との間で本サービスの利用契約（以下「サービス利用契約」といいます。）を締結することにより利用いただくことができます。',
      '本サービスは、以下のサービスで構成されております。なお、本サービスの具体的な内容につきましては、当社の都合により変更することがあります。',
      '当社製品（当社が本サービスを通じて販売する製品を指します。以下同様。）の通信販売サービス（次号のサービスを除く。）',
      '当社製品の定期購入サービス（以下「定期コース」といいます。）',
    ],
  },
  {
    type: 'text',
    content: '第3条　本サービスの利用',
  },
  {
    type: 'orderedList',
    contents: [
      '本規約に基づき利用登録が完了したお客様は、サービス利用契約の有効期間内に限り、本規約の目的の範囲内でかつ本規約に違反しない範囲内で、当社の定める方法に従い、本サービスを利用することができます。',
      'お客様は本サービスを日本国内において利用するものとします。',
    ],
  },
  {
    type: 'text',
    content: '第4条　会員登録',
  },
  {
    type: 'orderedList',
    contents: [
      '本サービスの利用を希望される方が当社の定める方法によって会員登録を申請し、当社がこれを承諾することによって、会員登録が完了するものとします。',
      '当社は、会員登録の申請をされた方に以下の事由があると判断した場合、会員登録をお断りすることがあり、その理由については一切の開示義務を負わないものとします。',
      '本規約に違反したことがある場合又は本規約に違反するおそれがあると当社が合理的に判断した場合',
      '会員資格取消処分を受けたことがある場合',
      '会員登録申請時に虚偽の情報を入力するなど当社に対して虚偽の情報を提供した場合',
      '本サービスを利用して購入した当社製品その他当社製作物の転売又は不正使用を目的としている場合',
      'その他、当社が本サービスの会員登録申請を承諾することが適当でないと合理的に判断した場合',
      '本規約に基づくサービス利用契約は、当社がお客様に対して、本サービスを利用するための ID 及びパスワードの設定が当社において完了し、お客様に対して当社が送信した会員登録完了メールが到達した時に、お客様と当社の間に成立します。',
      'お客様は、登録情報に変更があった場合は、遅滞なく、当社の定める方法により、変更手続を行うものとします。',
    ],
  },
  {
    type: 'text',
    content: '第5条　お申込み及び配送について',
  },
  {
    type: 'text',
    content:
      'お客様は、当社が指定する方法に従い、本サービスにおいて当社製品の購入をお申込みいただけます。',
  },
  {
    type: 'text',
    content: 'この場合において、当社はお客様からのお申込み内容を確認し、製品を配送します。',
  },
  {
    type: 'text',
    content:
      '当社とお客様との当該製品の売買契約（以下「個別契約」といいます。）は、当社からの製品発送メールをもって承諾の意思表示とし、当該メールがお客様に到達した時点で成立するものとします。',
  },
  {
    type: 'text',
    content:
      '当社は、前項のお申込みを受けた場合であっても、お客様が以下のいずれかに該当する場合には、お客様からのお申込みをお断りする場合があります。',
  },
  {
    type: 'orderedList',
    contents: [
      '本規約に違反したことがある場合又は本規約に違反するおそれがあると当社が合理的に判断した場合',
      'お届け先に日本国外の住所が指定された場合',
      '一度に大量の注文を行った場合',
      '虚偽の情報を入力するなど当社に対して虚偽の情報を提供した場合',
      '本サービスを利用して購入した当社製品その他当社製品の転売又は不正使用を目的としている場合',
      '第三者になりすまして製品の注文を行った場合',
      '登録されたメールアドレスに対するメールの配信が不達となった場合',
      'クレジットカード会社の支払承認が受けられないことが明らかとなった場合',
      '当社がお客様からのお申込みに関してお客様に連絡を取ったものの、1週間以上ご連絡が取れない場合',
      'その他当社がお客様からの申込みをお断りする必要があると合理的に判断した場合',
    ],
  },
  {
    type: 'text',
    content:
      'お客様にご注文いただいた当社製品は、当社の指定する配送業者によりお客様にお届けするものとします。',
  },
  {
    type: 'text',
    content:
      'お客様は、当社製品の配送にかかる送料を、次条第1項に規定する方法により支払うものとします。',
  },
  {
    type: 'text',
    content: 'ただし、当社が指定する要件を満たす場合には、当社が送料を負担します。',
  },
  {
    type: 'text',
    content: 'お客様は、当社製品の配送について、あらかじめ以下の事項を確認し、同意します。',
  },
  {
    type: 'text',
    content: '当社製品は、お客様からのお支払いを確認後、原則として3営業日以内に発送します。',
  },
  {
    type: 'text',
    content:
      '当社製品の配送は、通常は発送後3~5日でお届けできますが、地域によってはお届け日数に違いがあります。',
  },
  {
    type: 'text',
    content:
      '天候または交通事情、当社の休業期間等により、お客様に対してご案内したお届け予定日より遅れてのお届けとなる場合があります。',
  },
  {
    type: 'text',
    content: 'ご注文された当社製品の種類によっては、同時に発送できない場合があります。',
  },
  {
    type: 'text',
    content:
      'ご注文いただいた当社製品についてリニューアル、終売又は売り切れとなった場合、当社は、予告なくリニューアル後の製品のお届けや、製品のお届けを終了することができるものとします。',
  },
  {
    type: 'text',
    content: '第6条　お支払いについて',
  },
  {
    type: 'text',
    content:
      'お客様は、個別契約にかかる当社製品の対価として、別途当社が定め、当社ウェブサイトに表示する料金を、当社が指定する支払期日までに、当社が指定する支払方法により支払うものとします。',
  },
  {
    type: 'text',
    content: '第7条　定期コースについて',
  },
  {
    type: 'orderedList',
    contents: [
      '定期コースとは、当社が本規約の内容およびお客様によるご注文登録内容に従い、その都度注文を受けることなく、お客様から休止や解約の連絡を受けるまで、一定期間定期的に当社製品をお届けするサービスをいいます。',
      '定期コースの内容変更（お届けの時期、対象製品、数量、お届け先の住所等）、配送の休止又は解約（以下「定期コースの変更等」といいます。）は、当社ウェブサイトにおいて製品ごとに当社が定めた定期コース所定の受取回数を満了した後から可能となり、所定の受取回数を満了する以前の定期コースの変更、配送の休止又は解約はできません。',
      'お客様は、定期コースの変更等を希望する場合には、次回のお届け予定日から起算して10日前までに、当社が指定する方法により当該変更等の旨を当社に連絡しなければならず、次回お届け予定日まで10日を切ってからお客様の定期コースの変更等の連絡が当社に到達した場合、当社は、お客様からの従前の指定に従い、次回の定期コースにかかる当社製品のお届けを継続します。',
    ],
  },
  {
    type: 'text',
    content: '第8条　返品・交換・返金について',
  },
  {
    type: 'orderedList',
    contents: [
      '個別契約における当社製品についてのご返品は、当社製品がお客様に到着後８日以内に当社が別途指定する方法によりご連絡いただき、かつ当該製品が未開封の場合に限りお受けいたします。',
      'また、お客様のご都合による返品の場合、返品にかかる返送料はお客様のご負担となります。',
      '前項の規定に従い、当社にご連絡をいただいた場合であっても、当該個別契約締結以前に当社製品の返品、交換を何度も繰り返された場合、今後は返品、交換に応じられない旨を当社がお客様にお伝えしている場合、その他不当な動機に基づくご連絡であると当社が合理的に判断した場合には、前項の規定にかかわらず、当社製品の返品や交換をお断りすることがあります。',
      '配送中の事故等による破損又は汚損等が発生した場合やご注文いただいた当社製品や数量に齟齬がある場合など、お届けした当社製品の品質又は数量が契約内容に適合しない場合は、当社製品到着後8日以内に当社にご連絡いただいた場合に限り、返品又は交換の対応をいたします。',
      'なお、交換対応の場合には、お客様から当社製品をご返送いただき当社に到着次第、速やかに代替商品を発送させていただき、この場合の送料は当社が負担するものとします。',
      'まとめ買い又は定期コースによる割引制度を利用してご購入いただいた場合は、ご購入時の割引単価ではなく、お客様が既に消費（開封）された当社製品を、本来の販売価格に割り当てた上で、ご購入時のお支払額との差額を返金いたします。',
    ],
  },
  {
    type: 'text',
    content: '例：',
  },
  {
    type: 'text',
    content: '・ラフィーネ-アルファ6箱をお買い上げ後、2箱ご返品の場合',
  },
  {
    type: 'text',
    content: '《お買い上げ金額》',
  },
  {
    type: 'text',
    content: '①ラフィーネ-アルファ 6箱：7,000円(6箱以上で3割引)×6＝42,000円',
  },
  {
    type: 'text',
    content: '合計：42,000円',
  },
  {
    type: 'text',
    content: '《返品時の消費済み製品の算定》',
  },
  {
    type: 'text',
    content: '②ラフィーネ-アルファ 4箱：8,000円(3箱以上で2割引)×4=32,000円',
  },
  {
    type: 'text',
    content: '合計：32,000円',
  },
  {
    type: 'text',
    content: 'この場合、返金額は①42,000円−②32,000円＝10,000円となります。',
  },
  {
    type: 'text',
    content:
      '返金方法は、現金書留またはご指定の金融機関への送金をお選びいただけます。この場合には、現金書留送料や振込手数料等、返金に際して発生した各種手数料を差し引いた額が返金額となります。',
  },
  {
    type: 'text',
    content: '第9条　個人情報の管理',
  },
  {
    type: 'text',
    content:
      '当社は、お客様に関する個人情報（個人情報の保護に関する法律（平成15年法律第57号）において定義される「個人情報」をいいます。以下同様。）を以下の「個人情報取り扱いに関する公表事項」に従って適切に取り扱うものとします。',
  },
  {
    type: 'text',
    content: '◆「個人情報取り扱いに関する公表事項」',
  },
  {
    type: 'inlineLink',
    content: 'NUXT_PUBLIC_PUBLISHED_URL/?_ebx=aegjwgdnc.1647481937.7n0vvt',
    to: 'NUXT_PUBLIC_PUBLISHED_URL/?_ebx=aegjwgdnc.1647481937.7n0vvt',
  },
  {
    type: 'text',
    content: '第10条　権利の帰属',
  },
  {
    type: 'orderedList',
    contents: [
      '当社ウェブサイトに関する知的財産権は全て当社又は当社にライセンスを許諾している第三者に帰属します。',
      '当社ウェブサイトにおけるテキスト、画像、音声、映像、ソフトウェア等について、当社又は当社にライセンスを許諾している第三者の知的財産権を侵害するおそれのある一切の行為を行うことを禁じます。',
      '当社は、お客様から寄せられた感想、作品、写真、記事、メッセージ等（以下「お客様からの情報等」といいます。）について、当社がその主旨を変えないことを前提に表現調整し、お客様の同意を得た上で当社ウェブサイト内への掲載および広告等に使用させていただくことがあります。',
      'お客様は、前項の同意を行うにあたり、お客様からの情報等について著作権（著作権法第 27 条及び第 28 条に定める権利を含む。）その他の一切の権利を当社に無償で譲渡するものとし、お客様は当社又は当社がライセンスを許諾した第三者に対し、著作人格権等の権利を行使しないものとします。',
      'また、同意にあたり、お客様からの情報等が著作権・肖像権を含む第三者の権利を侵害していないことを確認いただくものとします。',
    ],
  },
  {
    type: 'text',
    content: '第11条　禁止事項',
  },
  {
    type: 'text',
    content:
      'お客様は、本サービスを利用するに際し、以下のいずれかに該当する行為をしてはなりません。',
  },
  {
    type: 'orderedList',
    contents: [
      '本規約、国内外の法令等又は公序良俗に反する態様により本サービスを利用する行為',
      '当社又は第三者の権利を侵害する行為',
      '以下に該当すると当社が判断する情報を、当社又は他のお客様に対して送信する行為',
      'コンピューター・ウィルス等の有害なプログラムを含む情報',
      '当社、本サービスの他のお客様又はその他の第三者の財産・信用・名誉・プライバシーを侵害する表現を含む情報',
      '違法行為・犯罪行為・反社会的行為を助長する表現を含む情報',
      '他人に不快感を与える表現を含む情報',
      '宣伝、広告、勧誘又は営業行為を含む情報',
      '本サービスのネットワーク又はシステムに過度な負荷をかける行為',
      '故意に虚偽のデータ等を入力する行為',
      '本サービスを利用する他のお客様の情報の収集を目的とする行為',
      '本システムについて、権限なく不正にアクセスする行為',
      '他のお客様又は第三者に成りすます行為',
      '国外において本サービスを利用する行為',
      '返品または交換を繰り返して当社に損害を与える行為',
      '個別契約に関する当社からの問い合わせに対して正当な理由なく2週間以上回答しない行為',
      'その他本サービス運営の妨げとなる又はそのおそれがあると当社が判断する行為',
    ],
  },
  {
    type: 'text',
    content: '第12条　反社会的勢力の排除',
  },
  {
    type: 'orderedList',
    contents: [
      'お客様は、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下これらを「反社会的勢力」といいます。）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを保証します。',
      '反社会的勢力が経営を支配していると認められる関係を有すること',
      '反社会的勢力が経営に実質的に関与していると認められる関係を有すること',
      '自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に反社会的勢力を利用していると認められる関係を有すること',
      '反社会的勢力に対して資金等を提供し、又は便宜を供与するなどの関与をしていると認められる関係を有すること',
      '役員又は経営に実質的に関与している者が反社会的勢力と社会的に非難されるべき関係を有すること',
      'お客様は、自ら又は第三者を利用して次の各号のいずれに該当する行為を行わないことを表明し、保証します。',
      '暴力的な要求行為',
      '法的な責任を超えた不当な要求行為',
      '取引に関して、脅迫的な言動をし、又は暴力を用いる行為',
      '風説を流布し、偽計を用い又は威力を用いて当社の信用を毀損し、又は当社の業務を妨害する行為',
      'その他前各号に準ずる行為',
    ],
  },
  {
    type: 'text',
    content:
      'お客様が、反社会的勢力若しくは第1項各号のいずれかに該当し、若しくは前項各号のいずれかに該当する行為をし、又は第1項の規定に基づく表明・確約に関して虚偽の申告をしたことが判明し、お客様との取引を継続することが不適切であると当社が判断した場合には、お客様は当社から請求があり次第、当社に対する一切の債務の期限の利益を失い、債務がある場合には直ちに債務を弁済します。',
  },
  {
    type: 'text',
    content:
      'お客様が、反社会的勢力若しくは第1項各号のいずれかに該当し、若しくは第2項各号のいずれかに該当する行為をし、又は第1項の規定に基づく表明・確約に関して虚偽の申告をしたことが判明した場合、当社は、催告することなく本サービスの提供を即時に停止し、契約を解除することができるものとします。',
  },
  {
    type: 'text',
    content:
      '前項に基づく本サービスの提供の停止及び解除に関して生じた損害、損失、その他の費用の賠償又は補償等につき、当社は一切の責任を負いません。',
  },
  {
    type: 'text',
    content:
      'お客様は、当社が第3項及び第4項の該当性の判断のために調査を要すると判断した場合、その調査に協力し、これに必要と判断する資料を提出しなければなりません。',
  },
  {
    type: 'text',
    content: '第13条　当社によるお取引の制限または解除について',
  },
  {
    type: 'text',
    content:
      '当社はお客様が以下の行為に該当する場合、お客様に事前通知することなく、本サービスに関連する取引を制限、解除できるものとします。',
  },
  {
    type: 'orderedList',
    contents: [
      'お客様が本規約または個別契約に違反した場合',
      'お客様が18歳未満の方で、かつ法定代理人の同意を得ないまま個別契約を締結した場合',
      '当社からの問い合わせ連絡に対して正当な理由なく1週間以上ご回答いただけない場合',
    ],
  },
  {
    type: 'text',
    content: '第14条　お問い合わせ先について',
  },
  {
    type: 'text',
    content:
      '本サービスに関するお客様からのお問い合わせその他の連絡は、当社が別途公表する問い合わせ窓口から行うものとします。',
  },
  {
    type: 'text',
    content: '第15条　免責事項',
  },
  {
    type: 'orderedList',
    contents: [
      '当社は、本規約に定める本サービスの提供の中断、停止、終了、利用不能又は変更、お客様が本サービスに提供した情報の削除又は消失、お客様情報等の抹消その他本サービスに関してお客様が被った損害につき、当社に故意又は過失がない限り、一切責任を負いません。',
      'お客様と第三者との間で紛争が生じた場合には、お客様は自身の責任と費用でこれを解決するものとし、当社はこれに一切関与しません。',
      '当社のお客様に対する義務の全部または一部の履行が、天変地異、戦争、重大な疫病、禁輸、通常の輸送・通信・送金手段の途絶、電力供給の停止、法令の改廃、公権力による命令等の当社の支配が及ばない事由により遅延し、または不能となった場合には、当社はその責任を負わないものとします。',
      'ただし、当社は、当該事由が除去されたときは、速やかに義務を履行するものとします。',
      '当社ウェブサイトから他のウェブサイトへのリンク又は他のウェブサイトから当社ウェブサイトへのリンクが提供されている場合でも、当社は、当社ウェブサイト以外のウェブサイト及びそこから得られる情報に関して如何なる理由に基づいても一切の責任を負いません。',
      'お客様が本サービスに登録したお客様の情報、ID及びパスワードの管理不十分又は使用上の過誤による損害の責任はお客様が負うものとし、当社は当社に故意又は過失がない限り、一切の責任を負いません。',
      'また、お客様の故意又は過失により第三者にこれらの情報が流出し、第三者がお客様のアカウント情報を利用した結果、お客様に発生した損害につき、当社は当社に故意又は過失がない限り、一切責任を負いません。',
      '本規約において当社がお客様に対して損害賠償責任を負う場合であっても、当社の賠償責任の範囲は、当社の責に帰すべき事由により現実に発生した直接かつ通常の損害に限られるものとし、かつ、損害の事由が生じた時点から遡って過去6か月間に当該お客様から現実に受領した対価の総額を上限とします。',
      'ただし、本項は、当社に故意又は重過失がある場合には適用されません。',
    ],
  },
  {
    type: 'text',
    content: '第16条　利用規約の変更',
  },
  {
    type: 'text',
    content:
      '当社は、民法第548条の4の規定に基づき本サービスの内容又は本規約を法令に違反しない範囲で変更できるものとします。',
  },
  {
    type: 'text',
    content:
      'この場合には、当社は、お客様に当該変更を行う旨、変更後の内容及び変更の効力発生日を当社ウェブサイトへの掲載による公表その他適切な方法で周知いたします。',
  },
  {
    type: 'text',
    content: '第17条　本サービスの変更・終了に関する事項',
  },
  {
    type: 'orderedList',
    contents: [
      '当社は当社の都合によりいつでもお客様の了承を得ることなく、本サービスの内容を変更、停止、終了することができます。変更後は本サービスの内容が適用されるものとします。',
      '当社の本サービスの変更、停止、終了によりお客様に不利益や損害が発生したとしても、当社は、故意又は過失がない限り一切の責任を負わないものとします。',
    ],
  },
  {
    type: 'text',
    content: '第18条　損害賠償',
  },
  {
    type: 'orderedList',
    contents: [
      'お客様は、本規約に違反することにより、又は本サービスの利用に関連して当社に損害を与えた場合、当社に対しその全ての損害（間接損害を含む。）を賠償しなければなりません。',
      '当社は、本サービスに関連してお客様が被った損害について、当社に故意又は過失がない限り一切賠償の責任を負いません。',
    ],
  },
  {
    type: 'text',
    content: '第19条　権利義務の譲渡禁止等',
  },
  {
    type: 'orderedList',
    contents: [
      'お客様は、本規約上の地位、本規約に基づく権利又は義務の全部又は一部を他に譲渡、承継若しくは担保に供してはならないものとします。',
      '当社が本サービスにかかる事業を第三者に譲渡（当社が消滅会社又は分割会社となる合併又は会社分割等による包括承継を含みます。）した場合には、当該譲渡に伴いサービス利用契約上の地位、本規約に基づく権利及び義務並びにお客様情報等を当該譲渡の譲受人に譲渡できるものとし、お客様は、かかる譲渡につきあらかじめ同意したものとみなします。',
    ],
  },
  {
    type: 'text',
    content: '第20条　分離可能性',
  },
  {
    type: 'text',
    content:
      '本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有し、当社及びお客様は、当該無効若しくは執行不能の条項又は部分を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効若しくは執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果を確保できるように努めるものとします。',
  },
  {
    type: 'text',
    content: '第21条　準拠法及び管轄',
  },
  {
    type: 'orderedList',
    contents: [
      '本規約の成立、効力、履行および解釈については、日本法を準拠法とします。',
      'お客様と当社の間で紛争が生じた場合には、東京地方裁判所をもって第一審の専属的合意管轄裁判所とします。',
    ],
  },
  {
    type: 'text',
    content: '第22条　存続条項',
  },
  {
    type: 'text',
    content:
      '第1条、第4条、第5条、第6条、第7条、第8条、第9条、第10条、第11条、第12条、第13条、第15条、第16条、第17条、第18条、第19条、第20条、前条及び本条の規定は、サービス利用契約が終了した場合であっても有効に存続します。',
  },
  {
    type: 'text',
    content: '第23条　協議',
  },
  {
    type: 'text',
    content:
      'お客様と当社との間の本サイトの利用に関して、本規約により解決できない問題が生じた場合、お客様と当社とは誠意をもって協議しこれを解決するものとします。',
  },
  {
    type: 'text',
    content: '＜付則＞',
  },
  {
    type: 'text',
    content: 'この規約は' + EFFECTIVE_DATE_IN_PRIVACY_POLICY_AND_TERMS_OF_USE + 'から実施します。',
  },
] as const;
// 個人情報の取り扱い
export const PRIVACY_POLICY: ReadonlyArray<CommonDetail> = [
  {
    type: 'text',
    content: 'ご利用にあたって',
  },
  {
    type: 'text',
    content:
      'オリエンタルバイオ株式会社のWEBサイトをご利用いただく前に下記のご利用条件をお読みいただき、ご同意の上ご利用いただきますようお願い申し上げます。',
  },
  {
    type: 'text',
    content: '万が一、ご同意いただけない場合は、大変申し訳ございませんがご利用をお控えください。',
  },
  {
    type: 'text',
    content: 'ご利用いただいた場合は、下記の諸条件をすべてご同意頂いたものとさせていただきます。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: 'ご利用条件',
  },
  {
    type: 'text',
    content: '【当サイトにおける個人情報の取り扱い】',
  },
  {
    type: 'text',
    content: '1. 組織の名称',
  },
  {
    type: 'text',
    content: HEADQUARTERS_NAME,
  },

  {
    type: 'text',
    content: HEADQUARTERS_POSTAL_CODE + ' ' + HEADQUARTERS_ADDRESS,
  },

  {
    type: 'text',
    content: '代表取締役社長　' + HEADQUARTERS_COO_NAME,
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '2. 個人情報保護管理者',
  },
  {
    type: 'text',
    content:
      HEADQUARTERS_NAME +
      ' 情報システム本部長 連絡先:' +
      HEADQUARTERS_PERSONAL_INFORMATION_TELEPHONE_NUMBER,
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '3. 個人情報の利用目的について',
  },
  {
    type: 'text',
    content: 'お客様に関する個人情報',
  },
  {
    type: 'orderedList',
    contents: [
      '①お客様に適した商品やサービスの紹介、案内、提案等のため。',
      '②商品の発送、代金の請求、決済等のため。',
      '③商品やサービスのカタログ・情報誌・ＤＭ・メールマガジンの送付等のため。',
      '④商品やサービスに関するアンケート、マーケティング、販売促進の実施等のため（※１、※２、※３、※４）。',
      '⑤新商品や新サービスの企画・立案等のため。',
      '⑥お問い合わせの対応やアフターサービスの提供、当社サービスの改善・品質向上、お客様との最適なコミュニケーション等のため。',
    ],
  },
  {
    type: 'text',
    content:
      '※１：お客様から取得したWebサイトの閲覧（訪問）履歴や購買履歴等の情報を分析して、サービスの提供、広告配信等に利用する場合を含みます。',
  },
  {
    type: 'text',
    content:
      '※２：Web広告の効果測定のため、お客様がアフィリエイトサイト経由で当社Webサイトを訪問されて当社の商品をご購入頂いた場合、当社Webサイトの訪問前にクリックされた広告情報（クリック日や広告掲載サイト等）を取得して、お客様の購買履歴と照合する場合があります。',
  },
  {
    type: 'text',
    content:
      '※３：当社以外の第三者から取得したお客様の趣味嗜好・閲覧履歴等の情報を、当社が既に有しているお客様の個人情報と紐づけて利用する場合があります。この場合には、お客様からあらかじめ同意を取得するとともに、上記に掲げる利用目的の範囲内において利用いたします。',
  },
  {
    type: 'text',
    content:
      '※４：当社のWebサイトでは、お客様の閲覧状況を把握するためにGoogle社等のサービスであるGoogle アナリティクス 4（GA4）（以下、「GA4」と略します。）、CATSを利用しており、同社は当社が発行するCookie（クッキー）を利用して（※５）、お客様の当社Webサイトの閲覧履歴を収集、記録、分析します。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content:
      '当社は、Google社等から分析結果を受け取り、お客様の当社Webサイトの閲覧状況を把握します。',
  },
  {
    type: 'text',
    content:
      'GA4、CATSにより収集、記録、分析されたお客様の情報には、特定の個人を識別する情報は一切含まれておりません。',
  },
  {
    type: 'text',
    content:
      'また、それらの情報は、Google社等により同社のプライバシーポリシーに基づいて管理されます。',
  },
  {
    type: 'text',
    content:
      'お客様は、ブラウザのアドオン設定でGA4、CATSを無効にすることで、ご自身の情報の収集を停止することが可能です。',
  },
  {
    type: 'text',
    content:
      'GA4、CATSの無効設定は、Google社等によるオプトアウトアドオンのページでブラウザのアドオン設定を変更して下さい。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content:
      'なお、お客様がGA4、CATSを無効設定した場合、当社のWebサイト以外のWebサイトでもGA4、CATSは無効になりますが、お客様がブラウザのアドオンを再設定することにより、再度GA4、CATSを有効にすることも可能です。',
  },
  {
    type: 'text',
    content:
      'GA4、CATSの利用規約に関する説明及び、プライバシーポリシーに関する説明については同社のサイトをご覧下さい。',
  },
  {
    type: 'text',
    content: '＜Google アナリティクス 4（GA4） の利用規約＞',
  },
  {
    type: 'inlineLink',
    content: 'https://marketingplatform.google.com/about/analytics/terms/jp/',
    to: 'https://marketingplatform.google.com/about/analytics/terms/jp/',
  },
  {
    type: 'text',
    content: '＜Google のプライバシーポリシー＞',
  },
  {
    type: 'inlineLink',
    content: 'https://policies.google.com/privacy?hl=ja',
    to: 'https://policies.google.com/privacy?hl=ja',
  },
  {
    type: 'text',
    content: '＜Google アナリティクス 4（GA4） オプトアウトアドオン＞',
  },
  {
    type: 'inlineLink',
    content: 'https://tools.google.com/dlpage/gaoptout/',
    to: 'https://tools.google.com/dlpage/gaoptout/',
  },
  {
    type: 'text',
    content: '＜CATSのプライバシーポリシー＞',
  },
  {
    type: 'inlineLink',
    content: 'https://markecats.co.jp/privacy/',
    to: 'https://markecats.co.jp/privacy/',
  },
  {
    type: 'text',
    content: '＜CATS（ジーニー）のオプトアウトアドオン＞',
  },
  {
    type: 'inlineLink',
    content: 'https://geniee.co.jp/optout/',
    to: 'https://geniee.co.jp/optout/',
  },
  {
    type: 'text',
    content:
      '※５：クッキー（Cookie）の利用については、「9．クッキー（Cookie）の取扱いについて」をご参照下さい。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '4．個人情報の安全管理措置について',
  },
  {
    type: 'text',
    content:
      '当社は、個人情報（当社が取得し、又は取得しようとしている個人情報を含む）の漏えい、滅失又はき損の防止等のために必要かつ適切な安全管理措置を講じます。',
  },
  {
    type: 'text',
    content:
      'また、個人情報を取り扱う役職員や委託先（再委託先等を含みます。）に対して、必要かつ適切な監督を行います。',
  },
  {
    type: 'text',
    content:
      '個人情報の安全管理措置の具体的な内容は、当社の「個人情報取扱管理規程」や「個人情報安全管理規程」（以下、「社内規程」と略します。）に定めておりますが、その主な内容は次の通りです。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（１）個人情報保護方針の策定',
  },
  {
    type: 'text',
    content:
      '個人情報の適正な取扱いの確保のため、「関係法令・ガイドライン等の遵守」や「質問及び苦情処理の窓口」等に関する基本方針（個人情報保護方針）を策定し、当社のＷｅｂサイト等にて公表しています。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（２）個人情報の取扱いに係る規律の整備',
  },
  {
    type: 'text',
    content:
      '個人情報の取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法、責任者・担当者及びその任務等について社内規程に定めています。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（３）組織的安全管理措置',
  },
  {
    type: 'text',
    content:
      '個人情報の取扱いに関する責任者を設置するとともに、個人情報を取り扱う役職員及び当該役職員が取り扱う個人情報の範囲を明確化し、個人情報保護法や社内規程に違反している事実又は兆候を把握した場合の責任者への報告連絡体制を整備しています。',
  },
  {
    type: 'text',
    content:
      'また、個人情報の取扱状況について定期的に自己点検を実施するとともに、社内他部署や外部の者による監査を実施しています。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（４）人的安全管理措置',
  },
  {
    type: 'text',
    content:
      '個人情報の取扱いに関して、役職員と秘密保持に関する誓約書を締結するとともに、定期的な教育・研修を実施しています。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（５）物理的安全管理措置',
  },
  {
    type: 'text',
    content:
      '個人情報を取り扱う区域において、役職員の入退室管理及び持ち込む機器等の制限を行うとともに、権限を有しない者による個人情報の閲覧を防止する措置を実施しています。',
  },
  {
    type: 'text',
    content:
      'また、個人情報を取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するための措置を講じるとともに、事業所内の移動を含め、当該機器、電子媒体等を持ち運ぶ場合は、容易に個人情報が判明しないような措置を実施しています。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（６）技術的安全管理措置',
  },
  {
    type: 'text',
    content:
      'アクセス制御を実施して、担当者が取り扱う個人情報データベース等の範囲を限定しています。',
  },
  {
    type: 'text',
    content:
      'また、個人情報を取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入しています。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '5．個人情報の第三者提供について',
  },
  {
    type: 'text',
    content:
      '当社は、次のいずれかに該当する場合を除き、事前にご本人の同意を得ることなく個人情報（要配慮個人情報を含む）を第三者に提供しません。',
  },
  {
    type: 'text',
    content: '（１）法令に基づく場合。',
  },
  {
    type: 'text',
    content:
      '（２）人の生命、身体又は財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき。',
  },
  {
    type: 'text',
    content:
      '（３）公衆衛生の向上又は児童の健全な育成の推進のために必要がある場合であって、ご本人の同意を得ることが困難であるとき。',
  },
  {
    type: 'text',
    content:
      '（４）国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '6．個人情報の取扱いの委託について',
  },
  {
    type: 'text',
    content:
      '当社は、業務を円滑に進めるとともに、より高品質なサービスを提供するため、当社が保有する個人情報の取扱いを協力会社に委託する場合がございます。',
  },
  {
    type: 'text',
    content:
      '但し、委託に際しては、当社が定める個人情報の保護水準と同等以上の者から委託先を選定するものとし、委託する個人情報は、委託業務の履行・実施に必要最小限の範囲とします。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '7．匿名加工情報の取扱いについて',
  },
  {
    type: 'text',
    content: '当社は、個人情報の匿名加工化作業及び匿名加工情報の取得・利用は行いません。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '8．音声データの取扱いについて',
  },
  {
    type: 'text',
    content: '当社は、次の目的のため、電話によるお客様との会話（音声）を録音させて頂きます。',
  },
  {
    type: 'text',
    content: 'なお、録音した内容（音声データ）は、本件目的の達成の範囲内でのみ利用しております。',
  },
  {
    type: 'text',
    content: '（１）ご注文内容の確認のため',
  },
  {
    type: 'text',
    content: '（２）お問い合わせ内容の確認のため',
  },
  {
    type: 'text',
    content: '（３）お客様に対するサービス提供品質の改善・向上のため',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '9．クッキー（Cookie）の取扱いについて',
  },
  {
    type: 'text',
    content:
      '当社のWebサイトでは、商品のご選択やご購入等の利便性の向上を目的として、クッキー（Cookie）という技術を利用しております。',
  },
  {
    type: 'text',
    content:
      '当社は、クッキーを利用することで、Webサイト利用者の利用履歴等を取得することはできますが、Webサイト利用者の個人情報を取得することはできません。',
  },
  {
    type: 'text',
    content:
      'ブラウザの設定により、いつでもクッキーの受取を拒否したり、クッキーを受け取った時に警告を表示することが可能です。',
  },
  {
    type: 'text',
    content:
      'ただし、その場合、当社Webサイトの機能が十分にご利用できない可能性がありますことをご了承ください。',
  },
  {
    type: 'text',
    content: '※これらの機能に関する情報は、ご利用のブラウザの「ヘルプ」をご覧ください。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content:
      'また、広告の配信を受託する第三者への委託に基づき、第三者を経由して、クッキー情報を保存し参照する場合があります。',
  },
  {
    type: 'text',
    content:
      'これを無効にしたい場合は、下記の各社オプトアウトページにアクセスし、手順に沿ってください。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '【Yahoo株式会社】',
  },
  {
    type: 'inlineLink',
    content: 'https://btoptout.yahoo.co.jp/optout/index.html',
    to: 'https://btoptout.yahoo.co.jp/optout/index.html',
  },
  {
    type: 'text',
    content: '【Google合同会社】',
  },
  {
    type: 'inlineLink',
    content: 'https://support.google.com/ads/answer/2662922?hl=ja',
    to: 'https://support.google.com/ads/answer/2662922?hl=ja',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '10．アクセスログの取扱いについて',
  },
  {
    type: 'text',
    content:
      '当社のＷｅｂサイトでは、Ｗｅｂサイトの改善やＷｅｂサイトの障害等が発生した場合の原因究明や復旧作業を目的として、Ｗｅｂサイト利用者のアクセス情報、操作情報をアクセスログとして記録して、統計・分析処理に利用しております。',
  },
  {
    type: 'text',
    content: 'なお、アクセスログは、個人を特定・識別できる情報を含むものではありません。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '11．ＳＳＬ／ＴＬＳの使用について',
  },
  {
    type: 'text',
    content:
      '当社のＷｅｂサイトでは、お客様の会員登録、資料のご請求、アンケートのご回答など、個人情報を含むデータを送受信する際には、ＳＳＬ（Secure Socket Layer）／ＴＬＳ（Transport Layer Security）による暗号化通信を使用し、Ｗｅｂサイト利用者の個人情報を外部の第三者が通信傍受できないよう対策を講じております。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '12．個人情報のご提供の任意性について',
  },
  {
    type: 'text',
    content: '当社に対する個人情報のご提供は、ご本人のご判断であり、全て任意となっております。',
  },
  {
    type: 'text',
    content:
      '但し、当社が依頼する個人情報をご提供頂けない場合は、当社は十分なサービスを提供できない場合がございます。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '13．開示等のご請求に応じるための手続きについて',
  },
  {
    type: 'text',
    content:
      '当社が保有する保有個人データについて、ご本人またはその代理人からの①利用目的の通知、②開示、③訂正・追加・削除、④利用の停止・消去・第三者提供の停止（以下、①から④を総称して「開示等のご請求」といいます）に対応させて頂く場合の手続きは、次の通りです。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（１）開示等のご請求の申し出先',
  },
  {
    type: 'text',
    content: '開示等のご請求を行う場合は、申請書に必要書類を添付の上、下記までご郵送して下さい。',
  },
  {
    type: 'text',
    content:
      'なお、ご郵送の際には封筒に「開示等請求書類在中」とお書き添えの上、配達記録郵便や簡易留郵便など、配達の記録が確認できる方法でお願いいたします。',
  },
  {
    type: 'text',
    content: HEADQUARTERS_POSTAL_CODE + ' ' + HEADQUARTERS_ADDRESS,
  },
  {
    type: 'text',
    content: HEADQUARTERS_NAME + ' ' + HEADQUARTERS_PERSONAL_INFORMATION_INQUIRY_COUNTER + '係',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（２）開示等のご請求における提出書類',
  },
  {
    type: 'text',
    content:
      '開示等のご請求を行う場合は、次の申請書（①）をダウンロードし、所定の事項を全てご記入の上、本人確認のための書類（②）を同封してご郵送して下さい。',
  },
  {
    type: 'text',
    content: '①当社所定の申請書 1 通',
  },
  {
    type: 'text',
    content: '・本人用申請書',
  },
  {
    type: 'inlineLink',
    content: '本人用申請書のダウンロードはこちらから',
    to: 'NUXT_PUBLIC_PUBLISHED_URL/images/01.pdf',
  },
  {
    type: 'text',
    content: '・代理人用申請書',
  },
  {
    type: 'inlineLink',
    content: '代理人用申請書のダウンロードはこちらから',
    to: 'NUXT_PUBLIC_PUBLISHED_URL/images/02.pdf',
  },
  {
    type: 'text',
    content: '②本人確認のための書類（ご本人を確認できる次のいずれかの写し） 1 通',
  },
  {
    type: 'text',
    content: '・運転免許証',
  },
  {
    type: 'text',
    content: '・パスポート',
  },
  {
    type: 'text',
    content: '・健康保険の被保険者証',
  },
  {
    type: 'text',
    content: '・住民基本台帳カード',
  },
  {
    type: 'text',
    content: '・在留カード',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（３）代理人による開示等の求め',
  },
  {
    type: 'text',
    content:
      '開示等のご請求を代理人に委任する場合は、上記（２）開示等の請求における提出書面に加えてそれぞれ次の書類をご同封下さい。',
  },
  {
    type: 'text',
    content: '①委任状 １通',
  },
  {
    type: 'inlineLink',
    content: '委任状のダウンロードはこちらから',
    to: 'NUXT_PUBLIC_PUBLISHED_URL/images/03.pdf',
  },
  {
    type: 'text',
    content: '②ご本人の印鑑証明書（3 ケ月以内に発行されたもの） 1 通',
  },
  {
    type: 'text',
    content: '③本人確認のための書類（代理人ご本人を確認できるもの、上記（２）②と同じ） 1 通',
  },
  {
    type: 'text',
    content:
      'なお、代理人が親権者などの法定代理人の場合は、上記①・②の書類に代えて戸籍謄本や住民票の写しなど、ご本人との関係がわかる書類をご提出頂くことも可能です。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（４）開示、利用目的の通知に関する手数料',
  },
  {
    type: 'text',
    content:
      '保有個人データの利用目的の通知や開示をご請求する場合、１回ごとに１０００円（消費税込み）の手数料を徴収させて頂きますので、１０００円分の郵便為替を提出書類にご同封下さい。',
  },
  {
    type: 'text',
    content:
      'なお、手数料が不足していた場合、または手数料が同封されていなかった場合は、その旨ご連絡申し上げますが、２週間以内にお支払いがなかった場合は、利用目的の通知や開示のご請求はなかったものとして対応させていただきます。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '（５）開示等の請求に対する回答方法',
  },
  {
    type: 'text',
    content:
      '開示等のご請求に対する回答は、ご請求者が申請書にご記入頂いた住所宛に書面を郵送致します。',
  },
  {
    type: 'text',
    content:
      'なお、法令の定め等により、開示等のご請求に応じることができない場合は、その理由を記述した書面を郵送致します。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '14．苦情・相談等の受付窓口について',
  },
  {
    type: 'text',
    content: '個人情報の取扱いに関する苦情・相談は、下記までお申し出ください。',
  },
  {
    type: 'text',
    content: HEADQUARTERS_POSTAL_CODE + ' ' + HEADQUARTERS_ADDRESS,
  },
  {
    type: 'text',
    content: HEADQUARTERS_NAME + ' ' + HEADQUARTERS_PERSONAL_INFORMATION_INQUIRY_COUNTER,
  },
  {
    type: 'text',
    content: '電 話：' + HEADQUARTERS_PERSONAL_INFORMATION_TELEPHONE_NUMBER,
  },
  {
    type: 'text',
    content: 'メールアドレス：' + HEADQUARTERS_PERSONAL_INFORMATION_EMAIL_ADDRESS,
  },
  {
    type: 'text',
    content: '※電話による受付時間は、' + HEADQUARTERS_TELEPHONE_SERVICE_HOURS + ' です。',
  },
  {
    type: 'text',
    content: '＜当社の所属する認定個人情報保護団体の名称及び苦情の申出先＞',
  },
  {
    type: 'text',
    content: '【認定個人情報保護団体の名称】',
  },
  {
    type: 'text',
    content: '公益社団法人日本通信販売協会（JADMA）',
  },
  {
    type: 'text',
    content: '〒103-0024 東京都中央区日本橋小舟町３－２ リブラビル２階',
  },
  {
    type: 'text',
    content: '電話 03-5651-1122',
  },
  {
    type: 'text',
    content: 'FAX 03-5651-1199',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '【リンク先に関する免責について】',
  },
  {
    type: 'text',
    content:
      '当サイトでは、ユーザーのプライバシーを保護するための最大限の努力をすることを約束いたします。',
  },
  {
    type: 'text',
    content:
      'ただし、当社のサイト上にあるリンク先の、第三者企業においては、当サイトの責任範囲外となり、その第三者企業が設定するプライバシーポリシーに準じることとなります。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '【掲載情報等について】',
  },
  {
    type: 'text',
    content:
      'オリエンタルバイオ株式会社が提供するウェブサイト内の掲載内容、掲載商品、商品価格、商品仕様は予告なしに変更されることがありますので、あらかじめご了承ください。',
  },
  {
    type: 'text',
    content: 'また、システムのメンテナンスにより、当サイトの運営を予告なく中断することがあります。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '【著作権について】',
  },
  {
    type: 'text',
    content:
      'オリエンタルバイオ株式会社が提供するウェブサイト内のコンテンツは現在から過去にさかのぼるまで、オリエンタルバイオ株式会社が一切の権利を所有し、著作権法で保護されているものとします。 ',
  },
  {
    type: 'text',
    content:
      '従って、情報・映像・音声等を権利者の許可なく複製、転用、販売などの二次利用することを禁じております。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '【商標について】',
  },
  {
    type: 'text',
    content:
      'オリエンタルバイオ株式会社が提供するウェブサイト内に記載されている、商品名やロゴ、サービス等はオリエンタルバイオ株式会社の商標、または登録商標です。',
  },
  {
    type: 'break',
  },
  {
    type: 'text',
    content: '【免責事項について】',
  },
  {
    type: 'text',
    content:
      'オリエンタルバイオ株式会社が提供するウェブサイト内は、安定稼働のためのシステム定期保守及び緊急保守、火災・停電によるシステム障害、その他やむをえずシステム停止が必要と当サイトが判断した場合、利用者へ予告なく停止できるものとします。',
  },
  {
    type: 'text',
    content:
      'また利用者の使用環境、ネットワークの接続状態、操作手順の不備によって生じた損害は保証しないものとします。',
  },
  {
    type: 'text',
    content: '当サイトにリンクしている他サイトの内容については一切の責任を負わないものとします。',
  },
] as const;
